// src/components/layout.js
import React, { useEffect } from "react"
import Header from "./Header/Header"
import Footer from "./Footer/Footer"
import GlobalStyles from "../assets/styles/GlobalStyles"
import {navigate} from "gatsby";
import ScrollTopButton from "../function/ScrollTopButton"
import Organization from "../micromarkup/Organization"
import OnlineStore from "../micromarkup/OnlineStore"
import Products from "../micromarkup/Products"
import Series from "../micromarkup/Series"
import Article from "../micromarkup/Article"
import AboutPage from "../micromarkup/AboutPage"
import { updateCartItem } from "../function/cartFunctions"
import SendDateN from "../function/sendDateN"
import { funMassage } from "../function/functions"

const Layout = ({ children, props  }) => {

    // const getData = props.pageContext === {} && true : false ;
    const getDataPageContext = props?.pageContext;
    const dataKey = props?.location.key;

    const templateName = props.pageContext?.templateFix || props.pageContext?.template?.templateName;

    // Функція для визначення класу шаблону сторінки
    const getTemplateClass = () => {
        if (Object.keys(getDataPageContext).length  === 0) {
            return "page404";
        } else {
            return templateName
        }
        // return templateName || "customPage";
    };

    const templateClass = getTemplateClass();


    const closePopInform = (op) => {
        if ( typeof document !== 'undefined' ) {
            if ( op === 'go' ) {
                // const button = typeof document !== 'undefined' && document.getElementById('showPop');
                const popInform = document.getElementById('popInform');
                popInform.classList.remove('active');

                const popInformGo = document.getElementById('popInformGo');
                const goAttributeValue = popInformGo.getAttribute('go');
                if ( goAttributeValue === 'cart' ) {
                    // console.log('cart >>>>>>>>', goAttributeValue)
                    // navigate(goAttributeValue)
                    document.getElementById('openCart').click();
                }
                if ( goAttributeValue === 'wishlist' ) {
                    // console.log('wishlist >>>>>>>>', goAttributeValue)
                    navigate('/wishlist/')
                    // document.getElementById('openCart').click();
                }

                if ( goAttributeValue === 'login' ) {
                    // console.log('login >>>>>>>>', goAttributeValue)
                    // navigate('/wishlist/')
                    document.getElementById('openAccountActive').click();
                }


            } else {
                const popInform = document.getElementById('popInform');
                popInform.classList.remove('active');


            }
        }
    }
    //
    // function closePopInform() {

    // }

    // Покинутий кошик, "one-click повернення": лист веде на головну з
    // параметром ?restore=id:qty,id:qty — тут за списком id підтягуємо
    // реальні дані товару (GetCartProducts, той самий шлях, що й "Повторити
    // замовлення" в OrderItem.js, лише без готового GraphQL-набору
    // товарів під рукою, тому окремий легкий запит), додаємо в кошик і
    // одразу відкриваємо попап — без переходу на кожен товар вручну.
    useEffect(() => {
        if (typeof window === 'undefined') return;

        const params = new URLSearchParams(props?.location?.search || window.location.search);
        const restoreParam = params.get('restore');
        if (!restoreParam) return;

        const pairs = restoreParam
            .split(',')
            .map((pair) => {
                const [id, qty] = pair.split(':');
                return { id: parseInt(id, 10), qty: parseInt(qty, 10) || 1 };
            })
            .filter((p) => Number.isInteger(p.id) && p.id > 0);

        if (pairs.length === 0) return;

        // Прибираємо ЛИШЕ "restore" з адресного рядка одразу — щоб
        // оновлення сторінки чи повторний перехід за цим самим лінком не
        // намагались відновити кошик вдруге поверх того, що людина вже
        // змінила сама. utm_* лишаємо в URL — captureUtmData()
        // (gatsby-browser.tsx, onClientEntry) вже встигла їх прочитати
        // до цього ефекту, і не варто без потреби чистити те, що вже
        // видно користувачу в адресному рядку.
        params.delete('restore');
        const cleanedSearch = params.toString();
        window.history.replaceState(
            null,
            '',
            window.location.pathname + (cleanedSearch ? `?${cleanedSearch}` : '')
        );

        SendDateN({
            type: 'GetCartProducts',
            data: { ids: pairs.map((p) => p.id) },
        }).then((res) => {
            const products = res?.products || [];
            const available = products.filter((p) => p.stockStatus !== 'outofstock');
            const unavailableCount = products.length - available.length;

            const items = available.map((p) => {
                const pair = pairs.find((x) => x.id === p.databaseId);
                return {
                    id: String(p.databaseId),
                    databaseId: p.databaseId,
                    title: p.title,
                    salePrice: p.salePrice,
                    regularPrice: p.regularPrice,
                    uri: p.uri,
                    step: pair ? pair.qty : 1,
                    featuredImage: { node: { localFile: { publicURL: p.imageUrl } } },
                };
            });

            if (items.length > 0) {
                // updateCartItem ВСТАНОВЛЮЄ точну кількість (замінює
                // рядок за id), а не додає її поверх наявної — інакше на
                // тому самому браузері, де кошик уже містив ці товари
                // (localStorage не чіпали), повторний перехід за
                // посиланням із листа щоразу подвоював би кількість.
                items.forEach((item) => updateCartItem(item));
                document.getElementById('openCart')?.click();
            }

            if (unavailableCount > 0) {
                const title = items.length > 0 ? "Додано не все" : "Товарів немає в наявності";
                funMassage(title, `<p>${unavailableCount} товар(и) з кошика вже недоступні.</p>`, "", "", "warning");
            }
        }).catch(() => {});
    }, []);

    // console.log('layout >>>>>>>>>', getDataPageContext )

    return (
        // <SmoothScroll>
        <div
            className={`body template-${templateClass} ${
                templateClass === 'page404' ? 'colorRevers' : ''
            }`}
        >
            <div id="scrollProgress" className="level1"></div>
            <GlobalStyles />
            <div className="container">
                <div className="wrapMain border-ver">
                    <Header isFrontPage={getDataPageContext.isFrontPage} colorRevers={templateClass === 'page404' ? 'colorRevers' : 'colorNormal'} />
                    <div className='main'>
                        {children}
                    </div>
                </div>
            </div>

            {/*{*/}
            {/*    console.log('props seoText >>>>>>>>>>>>', children )*/}
            {/*}*/}

            {getDataPageContext?.seoText?.seoActive ? (
                <div className="container">
                    <div className={`WrapDesc WrapFooterItem style-2`}>
                        <div className="row">
                            <div className="col-12 col-lg-5 col-xl-auto">
                                <div className='text st1 fw-3'>
                                    {getDataPageContext?.seoText?.seoTitle}
                                </div>
                            </div>
                            <div className="col-12 col-lg-7 col-xl">
                                <div className='wrapScroll'>
                                    <div className='st4 tc3 desc fw-3' dang erouslySetInnerHTML={{ __html: getDataPageContext?.seoText?.seoText }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : '' }

            {/*{templateClass === 'page404' ? null : (*/}
            {/*    */}
            {/*)}*/}

            <Footer isFrontPage={getDataPageContext?.isFrontPage} />

            <div id='popInform' className='popInform anim' type=''>
                <div className="container">
                    <div className="wrap row row-0">
                        <div className="col-12 col-lg-4">
                            <div id='popInformTitle' className='title st3'> </div>
                        </div>
                        <div className="col-sm">
                            <div className='text st5' id='popInformText'>

                            </div>
                        </div>
                        <div className="col-sm-auto d-flex align-items-center">
                            <div className="wrapBtn">
                                    <span id='popInformGo' go='' onClick={()=>closePopInform('go')} className="btn btn6">

                                    </span>
                            </div>
                            <span className="iconBG icon24 iconBG20" onClick={()=>closePopInform()} />
                        </div>
                    </div>
                </div>
            </div>

            <ScrollTopButton />

            {!["blog", "post", "Account"].includes(getDataPageContext?.templateFix) && (
                <Organization />
            )}

            {!["blog", "post", "Account"].includes(getDataPageContext?.templateFix) && (
                <OnlineStore />
            )}

            {getDataPageContext?.templateFix === "product" && (
                <Products {...props} />
            )}

            {/*{*/}
            {/*    console.log('props >>>>>>>>>>', getDataPageContext.slug )*/}
            {/*}*/}
            {/*templateFix === "categoriesProduct" && typePage === "series"*/}

            {getDataPageContext?.templateFix === "product" && getDataPageContext?.typePage === "series" && (
                <Series {...props} />
            )}

            {getDataPageContext?.templateFix === "post" && (
                <Article {...props} />
            )}

            {getDataPageContext?.slug === "about-us" && (
                <AboutPage {...props} />
            )}

        </div>
        // </SmoothScroll>
    );
}

export default Layout;